// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = ({
  backgrounds: { default: defaultBg },
  breakpoints: {
    values: { md }
  },
  palette: {
    primary = {},
    secondary = {},
    success = {},
    warning = {},
    info,
    error,
    grey: { G300, G500 }
  },
  text,
  shape: { borderRadius },
  spacing: { unit },
  zIndex: { modal: modalZIndex }
}) => ({
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 1)',
    bottom: 0,
    left: 0,
    opacity: 0.5,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 0
  },

  header: {
    padding: `${unit * 1.5}px ${unit * 2}px`,
    backgroundColor: G300,
    border: '0',
    borderRadius: `${borderRadius}px ${borderRadius}px 0 0`,
    overflow: 'auto'
  },

  content: {
    backgroundClip: 'padding-box',
    backgroundColor: defaultBg,
    border: `1px solid ${G500}`,
    borderRadius: `${borderRadius}px`,
    position: 'relative'
  },

  dialog: {
    color: text.primary,
    margin: `${unit * 2}px`,
    position: 'relative',
    width: 'auto',
    zIndex: 1,
    opacity: 1,

    [`@media only screen and (min-width: ${md}px)`]: {
      width: `${md}px`,
      margin: `${unit * 2}px auto`
    }
  },

  modal: {
    display: 'none',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: modalZIndex
  },

  modalIn: {
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'block'
  },

  primary: {
    color: primary.dark,
    backgroundColor: primary.light
  },
  secondary: {
    color: secondary.dark,
    backgroundColor: secondary.light
  },
  success: {
    color: success.dark,
    backgroundColor: success.light
  },
  warning: {
    color: warning.dark,
    backgroundColor: warning.light
  },
  info: {
    color: info,
    backgroundColor: info
  },
  error: {
    color: error,
    backgroundColor: error
  }
});

export default createUseStyles(styles);
